<div class="modal-header">
  <h5 class="modal-title">
    <i class="fas fa-exchange-alt me-2"></i>
    Transferir Atendimento
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="fechar()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="transferirForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <p class="text-muted mb-3">
        <i class="fas fa-info-circle me-2"></i>
        Selecione o atendente para o qual deseja transferir esta conversa.
        @if (nomeContato) {
          <strong>Contato: {{ nomeContato }}</strong>
        }
      </p>
    </div>

    <div class="row">
      <!-- Atendente Destino -->
      <div class="col-md-12 mb-3">
        <label class="form-label">
          Atendente Destino <span class="text-danger">*</span>
        </label>
        @if (isLoadingAtendentes) {
          <div class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
            <p class="text-muted mt-2 mb-0">Carregando atendentes...</p>
          </div>
        } @else {
          <select
            class="form-select form-select-sm"
            formControlName="atendenteId"
            [class.is-invalid]="submitted && f['atendenteId'].errors">
            <option value="">Selecione um atendente</option>
            @for (atendente of atendentes; track atendente.id) {
              <option [value]="atendente.id">
                {{ atendente.nomeCompleto }}
                <span class="badge ms-2" [ngClass]="{
                  'bg-success': atendente.status === 'online',
                  'bg-warning': atendente.status === 'ausente'
                }">
                  {{ atendente.status === 'online' ? 'Online' : 'Ausente' }}
                </span>
                @if (atendente.conversasAtivas !== undefined && atendente.maxConversasSimultaneas !== undefined) {
                  <span class="text-muted small ms-1">
                    ({{ atendente.conversasAtivas }}/{{ atendente.maxConversasSimultaneas }} conversas)
                  </span>
                }
              </option>
            }
          </select>
          @if (submitted && f['atendenteId'].errors) {
            <div class="invalid-feedback">
              @if (f['atendenteId'].errors['required']) {
                Atendente destino é obrigatório
              }
            </div>
          }
          @if (atendentes.length === 0 && !isLoadingAtendentes) {
            <div class="text-muted small mt-1">
              <i class="fas fa-exclamation-triangle me-1"></i>
              Nenhum atendente online ou ausente disponível
            </div>
          }
        }
      </div>

      <!-- Motivo (Opcional) -->
      <div class="col-md-12 mb-3">
        <label class="form-label">
          Motivo da Transferência <span class="text-muted">(Opcional)</span>
        </label>
        <textarea
          class="form-control form-control-sm"
          formControlName="motivo"
          rows="3"
          placeholder="Informe o motivo da transferência (opcional)"
          [class.is-invalid]="submitted && f['motivo'].errors">
        </textarea>
        @if (submitted && f['motivo'].errors) {
          <div class="invalid-feedback">
            {{ f['motivo'].errors | json }}
          </div>
        }
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-sm" (click)="fechar()" [disabled]="isLoading">
    Cancelar
  </button>
  <button
    type="button"
    class="btn btn-primary btn-sm"
    (click)="onSubmit()"
    [disabled]="isLoading || isLoadingAtendentes || atendentes.length === 0">
    @if (isLoading) {
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
    }
    Transferir
  </button>
</div>
